var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-layout",
      staticStyle: {
        "background-image":
          "url(/_resources/app/client/assets/images/savings-calculator-bg.jpg)",
      },
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("LetsGetStartedView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentView == "LetsGetStartedView",
                expression: "currentView == 'LetsGetStartedView'",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentView == "SliderView",
                expression: "currentView == 'SliderView'",
              },
            ],
          },
          [
            _c("ProgressBar"),
            _vm._v(" "),
            _c(
              "tiny-slider",
              {
                ref: "pageSlider",
                attrs: {
                  loop: false,
                  items: "1",
                  gutter: "20",
                  controls: false,
                  nav: false,
                  touch: false,
                },
              },
              [
                _c("PeopleQuestionView"),
                _vm._v(" "),
                _vm._l(_vm.Categories, function (category) {
                  return [
                    _vm._l(category.Questions, function (question) {
                      return [
                        _c("QuestionView", {
                          key: question.Id,
                          attrs: {
                            question: question,
                            categoryName: category.Name,
                          },
                        }),
                      ]
                    }),
                  ]
                }),
                _vm._v(" "),
                _c("SummaryView"),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("FinishView", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.currentView == "FinishView",
                expression: "currentView == 'FinishView'",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }